
import { useEffect, useState } from 'react';
import { FaMagnifyingGlass } from 'react-icons/fa6';
import { default as ReactSelect } from 'react-select';

/* eslint-disable react/prop-types */

function Form ({ children, title }) {
  return (
    <form className="w-full max-w-3xl mx-auto p-4 flex flex-col gap-3 bg-color2 rounded-sm ">
        <h2 className=" pb-4 text-2xl text-color5">{title}</h2>
      {children}
    </form>
  )
}

function Input({type, name, value, onChange, placeholder, required, label, id}) {
  return (
    <div className=" w-full h-max py-1 flex flex-col gap-1 text-color5 text-lg">
      {label && <label htmlFor={id}>{label}</label>}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        id={id}
        className=" w-full bg-color3 py-2 px-2 text-lg rounded-sm"
      />
    </div>
  )
}

function Select({ children, name, value, onChange, label, id}) {
  
  return (
    <div className=" w-full h-max py-1 flex flex-col gap-1 text-color5 text-lg">
      {label && <label htmlFor={id}>{label}</label>}
      <select
        name={name}
        value={value}
        onChange={onChange}
        id={id}
        className=" w-full bg-color3 py-[10px] px-2 text-lg rounded-sm"
      >
        {children}
      </select>
    </div>
  )
}

function Option({children, value}) {
  return (
    <option value={value}>{children}</option>
  )
}

function ToggleButton({ on: defaultOn = true, onClick }) {
  const [on, setOn] = useState(defaultOn);

  useEffect(() => { 
    setOn(defaultOn);
  }, [defaultOn]);

  const handleClick = () => {
    setOn(!on);
    if (onClick) {
      onClick(!on);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`w-14 h-8 flex items-center bg-color3 rounded-full p-1 cursor-pointer ${on ? 'bg-green-400' : 'bg-color3'}`}
    >
      <div
        className={`bg-color4 w-6 h-6 rounded-full shadow-md transform duration-300 ease-in-out ${on ? 'translate-x-6 bg-color5' : ''}`}
      ></div>
    </div>
  );
}

function SearchInput({ value, onChange, onSearch, placeholder }) {
  return (
    <div className="w-full h-max py-1 flex items-center text-color5 text-lg relative">
      <input
        title=' provide info to search'
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full bg-color3 py-2 px-2 text-lg rounded-sm pr-10"
      />
      <button
        title='click to show search results'
        onClick={onSearch}
        className="absolute right-1 bg-color2 py-2 px-3 text-lg rounded-md"
      >
        <FaMagnifyingGlass />
      </button>
    </div>
  );
}


const MultiSelect = ({title, options, getSelectedOptions, selectedOption  }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    getSelectedOptions(selectedOptions);
  }, [selectedOptions, getSelectedOptions]);
  useEffect(() => {
    if (JSON.stringify(selectedOptions) !== JSON.stringify(selectedOption)) {
      setSelectedOptions(selectedOption || []);
    }
  }, [selectedOption]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#292C2D",
      border: "1px solid #404142",
      borderRadius: "4px",
      padding: "5px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#404142",
      borderRadius: "4px",
      padding: "4px 8px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "white",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "white",
      ":hover": {
        backgroundColor: "#292C2D",
        color: "white",
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#292C2D",
      border: "1px solid #404142",
    }),
    option: (provided, { isFocused }) => ({
      ...provided,
      backgroundColor: isFocused ? "#292C2D" : "transparent",
      color: "white",
    }),
  };

  return (
    <div className=" text-color5">
      <h3 className="mb-2 font-semibold">{title}</h3>
      <ReactSelect
        isMulti
        options={options}
        value={selectedOptions}
        onChange={setSelectedOptions}
        styles={customStyles}
        className="text-black"
      />
    </div>
  );
};

export { Form, Input, Select, Option, ToggleButton, SearchInput, MultiSelect };